import React, { Component } from 'react';

import { translate } from 'react-i18next';

@translate(['common'])
export default class ReloadButton extends Component {
	constructor(props) {
		super(props)
		this.state = {
			loading: false,
		}
	}

	componentWillReceivedProp(nextProps) {

		if (nextProps.loading == false) {

		}
	}

	render() {

		const {t} = this.props

		return (

			<button className="btn btn-success"
				onClick={() => {
					if (!this.props.loading) {
						this.props.submit();
					}
				}}
			>
				<i className={'fa ' + (this.props.loading ? 'fa-refresh fa-spin' : 'fa-refresh')} /> {t("reloadButton.recharge_module", {modules:this.props.module})}
			</button>


		);
	}
}

